import React, { useState } from 'react';
import TabSlider, {TabSliderContent} from "../../../refactor/tabs/TabSlider";
import AccountDashboard from "./AccountDashboard";
import AccountSettings from "./AccountSettings";
import AccountPageHeader from './AccountPageHeader';
import { scrollToTopOfAccountPage } from '../../../utils/scrollToTopOfPage';
import StripePaymentProcessor from './checkout/StripePaymentProcessor';
import SubscriptionSelector from './checkout/SubscriptionSelector';

const ACCOUNTS_TAB_IDS = {
    dashboard: 'dashboard',
    custom: 'custom',
    settings: 'settings'
};
const SUBSCRIBE_STEPS = {
    SELECT: 'SELECT',
    PAY: 'PAY'
};
const componentClass = 'accounts-page';

const AccountsModule = () => {
    const [activeTab, setActiveTab] = useState(ACCOUNTS_TAB_IDS.dashboard);
    const [showSubscriberCheckout, setShowSubscriberCheckout] = useState(false);
    const [subscriptionOption, setSubscriptionOption] = useState(null);

    const onChangeTab = next => {
        scrollToTopOfAccountPage();
        setActiveTab(next);
    };

    const confirmLogout = () => {
        if (window.confirm('Are you sure you want to logout?')) {
            localStorage.clear();
            window.location.href = '/logout';
        }
    };

    const moduleTabs = [
        { label: 'Dashboard', key: ACCOUNTS_TAB_IDS.dashboard, children: <AccountDashboard
                onAccountsTabClick={() => onChangeTab(ACCOUNTS_TAB_IDS.settings)}
                onSubscriberCheckoutClick={() => setShowSubscriberCheckout(SUBSCRIBE_STEPS.SELECT)}
            />
        },
        { label: 'Account', key: ACCOUNTS_TAB_IDS.settings, children: <AccountSettings /> }
    ];

    const renderSubscriptionPicker = () => {
        const onReadyToPayClicked = subType => {
            setSubscriptionOption(subType);
            setShowSubscriberCheckout(SUBSCRIBE_STEPS.PAY);
        };
        return <div className="loginFlow">
            <div className="loginFlow__wrapper">
                <SubscriptionSelector onContinue={onReadyToPayClicked}/>
            </div>
        </div>;
    };

    const renderSubscriberCheckout = () => {
        const title = "NuStation Account Subscription";
        const description = "Your details have been prepped and you have arrived at the final stage: " +
            "The $pending Step! Once you complete the form below and payment is processed, " +
            "your account setup will be complete and you will be free to fly throughout the NuStation " +
            "to experience more sounds and sights!";
        return <div className="loginFlow">
            <div className="loginFlow__wrapper">
                <StripePaymentProcessor
                    products={subscriptionOption}
                    title={title}
                    description={description}
                    onCancel={() => setShowSubscriberCheckout(SUBSCRIBE_STEPS.SELECT)}
                />
            </div>
        </div>
    };

    const renderSubscriptionFlow = () => {
        if (showSubscriberCheckout === SUBSCRIBE_STEPS.SELECT) {
            return renderSubscriptionPicker();
        } else if (showSubscriberCheckout === SUBSCRIBE_STEPS.PAY) {
            return renderSubscriberCheckout();
        }
    };

    return showSubscriberCheckout ? renderSubscriptionFlow() : <React.Fragment>
        <AccountPageHeader
            title={"NuStation Account"}
            subtitle={"Welcome to your account dashboard! Review your purchases, recent music / videos, manage settings and more."}
            className={`${componentClass}__header`}
        >
            <TabSlider tabs={moduleTabs} onChange={onChangeTab} activeKey={activeTab} />
        </AccountPageHeader>
        <div className={`${componentClass}__headCap`} />
        <TabSliderContent tabs={moduleTabs} activeKey={activeTab} />
        <div className="logout-button">
            <button className="btn btn-dark-red" onClick={confirmLogout}>Logout</button>
        </div>
    </React.Fragment>;
};

export default AccountsModule;
